/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionQuotaFromJSON, SubscriptionQuotaToJSON } from './SubscriptionQuota';
/**
 * Check if a given object implements the SubscriptionResponse interface.
 */
export function instanceOfSubscriptionResponse(value) {
    if (!('currentPeriodEnd' in value) || value['currentPeriodEnd'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('tier' in value) || value['tier'] === undefined)
        return false;
    return true;
}
export function SubscriptionResponseFromJSON(json) {
    return SubscriptionResponseFromJSONTyped(json, false);
}
export function SubscriptionResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        ...json,
        'cancelAtPeriodEnd': json['cancel_at_period_end'] == null ? undefined : json['cancel_at_period_end'],
        'currentPeriodEnd': json['current_period_end'],
        'pendingDowngradeTier': json['pending_downgrade_tier'] == null ? undefined : json['pending_downgrade_tier'],
        'quota': json['quota'] == null ? undefined : SubscriptionQuotaFromJSON(json['quota']),
        'status': json['status'],
        'tier': json['tier'],
    };
}
export function SubscriptionResponseToJSON(json) {
    return SubscriptionResponseToJSONTyped(json, false);
}
export function SubscriptionResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        ...value,
        'cancel_at_period_end': value['cancelAtPeriodEnd'],
        'current_period_end': value['currentPeriodEnd'],
        'pending_downgrade_tier': value['pendingDowngradeTier'],
        'quota': SubscriptionQuotaToJSON(value['quota']),
        'status': value['status'],
        'tier': value['tier'],
    };
}
